import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const EstadosFacturacion = ({ loading, calculandoPrefactura, estadoFacturacion, mensajeFacturacion = "" }) => {
  let message = "";
  let showIcon = false;
  let icon = null;
  let color = "#2E86C1";

  if (loading) {
    message = "Cargando...";
  } else if (calculandoPrefactura) {
    message = "Calculando factura...";
  } else if (estadoFacturacion === "cargando") {
    message = "Procesando facturación...";
  } else if (estadoFacturacion === "exito") {
    message = "¡Facturado con éxito!";
    showIcon = true;
    icon = <CheckCircleIcon sx={{ fontSize: 48, color: "#27ae60" }} />;
    color = "#27ae60";
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight={200}
      gap={2}
    >
      {showIcon ? icon : <CircularProgress size={48} sx={{ color }} />}
      <Typography variant="h6" color={color} fontWeight="medium">
        {message}
      </Typography>
      <Typography variant="h6" color={color} fontWeight="medium">
        {mensajeFacturacion}
      </Typography>
    </Box>
  );
};

export default EstadosFacturacion;